import {
  CATEGORIES,
  initialPlayerValues,
  type PlayerCategory,
} from '../../profile/player'
import type { RosterPlayerFormValues } from './types'

/**
 * Roster section list: the shared profile categories with a roster-info section
 * inserted after Personal, then re-numbered so the sidebar shows 1..6 in order.
 */
const withoutPersonal = CATEGORIES.filter((c) => c.key !== 'personal')
const personal = CATEGORIES.find((c) => c.key === 'personal') as PlayerCategory

export const ROSTER_CATEGORIES: ReadonlyArray<PlayerCategory> = [
  personal,
  {
    key: 'rosterInfo' as PlayerCategory['key'],
    label: 'Roster Information',
    index: 0,
  },
  ...withoutPersonal,
].map((c, i) => ({ ...c, index: i + 1 }))

/**
 * Success confirmation copy for the player flows (roster add/edit, profile
 * edit). Single source of truth shared by mobile (SuccessBottomSheet
 * title/subtitle) and web (Ant toast rendered as "<title> — <subtitle>").
 */
export const PLAYER_SUCCESS_MESSAGES = {
  rosterAdd: {
    title: 'Player Added',
    subtitle: 'The player has been added to the roster.',
  },
  rosterEdit: {
    title: 'Changes Saved',
    subtitle: 'The player information has been updated.',
  },
  profileEdit: {
    title: 'Changes Saved',
    subtitle: 'The player information has been updated.',
  },
} as const

/** Blank roster form values: profile defaults + roster-field defaults. */
export const initialRosterPlayerValues: RosterPlayerFormValues = {
  ...initialPlayerValues,
  playerNumber: '',
  positionId: '',
  isInjured: false,
  isAffiliate: false,
  customerIdentifier: '',
  salesforceId: '',
}
